import { addBaseUrl } from "@kaltura/mediaspace-shared-utils";
import { StyledMenuItem, StyledListItemIcon } from "../StyledComponents";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType, KmsTypeAction } from "@kaltura/mediaspace-shared-types";
import { iconsMap } from "./icons";
import { MenuItemProps } from "@kaltura/ds-react-components";
import { ActionItemInjectedProps } from "../ActionItemInjectedProps";

export interface LinkActionProps extends Omit<MenuItemProps<"a">, "action">, ActionItemInjectedProps {
    action: Required<KmsTypeAction>;
}

/**
 * actions menu link item
 */
export const LinkAction = ({
    action: { link, attributes, label, analyticsValue },
    onCloseMenu,
    ...menuItemProps
}: LinkActionProps) => {
    const sendButtonAnalytics = useButtonAnalytics();

    const sendAnalytics = () => {
        if (analyticsValue) {
            sendButtonAnalytics(analyticsValue, ButtonClickAnalyticsType.CHOOSE);
        }
    };

    return (
        <StyledMenuItem {...menuItemProps} href={addBaseUrl(link.href)} component={"a"} onClick={sendAnalytics}>
            <StyledListItemIcon>{iconsMap[attributes.class]}</StyledListItemIcon>
            {label}
        </StyledMenuItem>
    );
};
